import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import { useGetChats } from "hooks/useGetChats";
import withRouter from "hoc/withRouter";
import { useContext, useState } from "react";
import {
  FaCircle,
  FaEllipsisH,
  FaUser,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toChatTime } from "helpers/dateHelper";
import { SocketContext } from "context/SocketProvider";
import _ from "lodash";
import { ChatSettingsForm } from "./ChatSettings";
import { getChatSettings } from "redux/selectors/getChatSettings";
import { useSelector } from "react-redux";

interface ChatListProps {
  selectedChatID: number | null;
  setSelectedChatID: (chatID: number | null) => void;
  router: any;
  socketMessage: any;
  isConnected: boolean;
}

/**
 * Список диалогов
 * @returns
 */
const ChatList = ({
  selectedChatID,
  setSelectedChatID,
  router: { params },
}: ChatListProps) => {
  const { send, isConnected } = useContext<any>(SocketContext);

  // Search query
  const [searchQuery, setSearchQuery] = useState<string>(new URLSearchParams(window.location.search).get("query") || '');

  const chatSettings: any = useSelector(getChatSettings);

  const { data: chats } = useGetChats({
    orgID: localStorage.getItem("orgID") as string,
    source: chatSettings?.source,
    externalAccountUserName: chatSettings?.externalAccountUserName,
    query: searchQuery,
  });

  const navigate = useNavigate();

  // Settings dialog
  const [isSettingsDialogOpen, setIsSettingsDialogOpen] = useState<boolean>(false);

  return (
    <div className="chat-list">
      <div className="chat-list-header flex flex-col">
        <div id="chats-header-title" className="mb-4">
          <span className="text-md font-bold">Все чаты</span>
        </div>
        <div id="chats-search" className="w-full">
          <TextField
            label="Поиск"
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              endAdornment: (
                <div className="flex items-center justify-center">
                  <FaCircle color={isConnected ? "green" : "orange"} size={12} />
                  <IconButton onClick={() => setIsSettingsDialogOpen(true)}><FaEllipsisH size={12} /></IconButton>
                </div>
              ),
            }}
          />
        </div>
      </div>
      <div className="chat-list-body">
        {chats
          ?.map((chat: any) => (
            <div
              className={`chat-list-item ${selectedChatID === chat.id ? "selected" : ""}`}
              key={chat.id}
              onClick={() => {
                // add chatID to query params
                navigate(`?chatID=${chat.id}`, { replace: true });
                setSelectedChatID(chat.id ?? null)
              }}
            >
              <div className="chat-list-item-name">
                <div className="flex items-center justify-between gap-2">
                  <div className="left">
                    <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden flex items-center justify-center">
                      {chat?.contact?.externalUserPhoto ? (
                        <img
                          src={chat?.contact?.externalUserPhoto}
                          alt="User Photo"
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <FaUser size={20} />
                      )}
                    </div>
                  </div>
                  <div className="right flex-1 overflow-hidden">
                    <div className="flex items-center justify-between gap-2">
                      <div
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "100%",
                        }}
                      >
                        {_.get(chat, "contact.externalUserFirstName") ||
                          _.get(chat, "contact.externalUserUserName") ||
                          _.get(chat, "contact.externalUserID") ||
                          _.get(chat, "externalUserFirstName")}
                      </div>
                      <div className="text-xs">{toChatTime(chat.updatedAt)}</div>
                    </div>
                    <div
                      className="text-sm text-gray"
                      style={{
                        fontWeight: 400,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        maxWidth: 220,
                      }}
                    >
                      {chat.lastMessage ? chat.lastMessage : "Нет сообщений"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
      <Dialog open={isSettingsDialogOpen} onClose={() => setIsSettingsDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Настройки чата</DialogTitle>
        <DialogContent>
          <ChatSettingsForm chatSettings={chatSettings} onClose={() => setIsSettingsDialogOpen(false)} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default withRouter(ChatList);
